<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'telefone_1'"
            v-model="formulario.telefone_1" 
            :placeholder="'Telefone 1'"
            data-vv-as="Telefone 1"
         />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'telefone_2'"
            v-model="formulario.telefone_2" 
            :placeholder="'Telefone 2'"
            data-vv-as="Telefone 2"
         />
      </div>
      
      <div class="container-botoes">
        <SGPFormBotaoComponent color="primary" type="submit">
          Atualizar
        </SGPFormBotaoComponent>
        <SGPFormBotaoComponent color="grey-3" type="button" @click="fecharModal()">
          Cancelar
        </SGPFormBotaoComponent>
      </div>
      
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioTelefonesUsuarioComponent",

  props: {
    usuario: {
      type: Object,
      required: false
    }
  },

  computed: {
    ...mapGetters("usuarios", ["loadingUsuario", "usuario"]),
    ...mapGetters('login', ['usuarioLogado']),
  },
    
  data () {
    return {
      formulario: this.$props.usuario || {
        telefone_1: '',
        telefone_2: '',
      }
    }
  },

  methods: {
    ...mapActions('usuarios', [
      'atualizarContatosUsuario',
      'getUsuario'
    ]),
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
            
          const resp = await this.atualizarContatosUsuario(this.formulario);

          if(!resp) {
            return;
          }

          this.fecharModal();
        }
      });      
    },

    fecharModal () {
      this.getUsuario(this.usuarioLogado.id);
      this.formulario = this.usuario
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>